import { connect } from 'react-redux';
import {
	DemographicQuestionList,
	IDemographicQuestionContainerParams,
} from '../../components/questions/demographic-questions/DemographicQuestionList';
import { IApplicationState } from '../../store';
import { ActionCreators as BenchmarksActionCreators } from '../../store/BenchmarksStore';
import { ActionCreators } from '../../store/CommonQuestionListActions';
import { ActionCreators as CulturesActionCreators } from '../../store/CulturesStore';

export const DemographicQuestionListContainer: React.ComponentType<IDemographicQuestionContainerParams> = connect(
	(state: IApplicationState) => ({
		...state.cultures,
		...state.benchmarks,
		...state.clientParticipantAttributes,
		...state.commonQuestionList,
		selectedBenchmarkIds: state.survey.surveyEditModel.benchmarks,
		surveySupportedCultures: state.survey.surveyEditModel.supportedCultures,
		loading: state.libraryQuestions.loading || state.clientParticipantAttributes.loading,
	}),
	{
		...ActionCreators,
		...CulturesActionCreators,
		...BenchmarksActionCreators,
	},
)(DemographicQuestionList);
